module.exports = __webpack_public_path__ + "img/site_type_img_18.f9fb0354.png";